export enum QuestionType {
  Boolean = "Boolean",
  Text = "Text",
  Checkbox = "Checkbox",
  ListOfContactPersons = "ListOfContactPersons",
  Certificates = "Certificates",
  CertificatesV2 = "CertificatesV2",
  BooleanWithDetails = "BooleanWithDetails",
  BooleanWithDetailsOnNo = "BooleanWithDetailsOnNo",
  BooleanWithMultiSelect = "BooleanWithMultiSelect",
  BooleanWithNotRelevant = "BooleanWithNotRelevant",
  Address = "Address",
  LeadText = "LeadText",
  TextArea = "TextArea",
  Select = "Select",
  Date = "Date",
  Consent = "Consent",
  ListOfCheckboxes = "ListOfCheckboxes",
  KeyPersonnel = "KeyPersonnel",
  BeneficialOwners = "BeneficialOwners",
  Phone = "Phone",
  Multiselect = "Multiselect",
  OwnershipPubliclyListedTypes = "OwnershipPubliclyListedTypes",
  OwnershipIndividual = "OwnershipIndividual",
  OwnershipCompany = "OwnershipCompany",
  PersonWithPepAndSanctions = "PersonWithPepAndSanctions",
  PersonsWithPepAndSanctions = "PersonsWithPepAndSanctions",
  PersonsNameAndPosition = "PersonsNameAndPosition",
}
